import * as React from 'react';
import RevenuesCore from '../AfrCore/RevenuesCore';

const Revenues = (props: any) => {

    return (
        <React.Fragment>
            <RevenuesCore userRole="ENTITY_USER" />
        </React.Fragment>
    );
}

export default Revenues;